import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateStandingsConfiguration } from "~pages/StandingsConfigurations/types/upsertStandingsConfiguration.ts";
import type { StandingConfigurationResponse } from "~types/standingConfiguration.ts";

export const useUpdateStandingsConfiguration = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<StandingConfigurationResponse, Error, UpdateStandingsConfiguration>({
    mutationFn: async ({ standingConfigurationId, ...body }) =>
      await request<StandingConfigurationResponse>(`${sport}/o/${organizationId}/standings/configurations/${standingConfigurationId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async (_response, { standingConfigurationId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["standingsConfigurations"] }),
        queryClient.invalidateQueries({ queryKey: ["standingsConfigurations", sport, organizationId] }),
        queryClient.invalidateQueries({
          queryKey: ["standingsConfigurations", organizationId, standingConfigurationId],
        }),
      ]);
    },
  });
};
